/*!
    Copyright (c) 2021 - present, Biwabits. 
    https://www.biwabits.com/
*/


const instances = {}

export const ComponentInstance = {
  methods: {
    getInstance(id) {
      return instances[id]
    },

    setInstance() {
      instances[this.id] = this
    }
  }
}